import { useState } from 'react';

export const useViewModels = () => {
  const [opacity, setOpacity] = useState(0.7);

  return {
    opacity,
    setOpacity,
  };
};
